import { render, staticRenderFns } from "./LayoutHandler.vue?vue&type=template&id=5bbb69e8&scoped=true&"
import script from "./LayoutHandler.vue?vue&type=script&lang=js&"
export * from "./LayoutHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb69e8",
  null
  
)

export default component.exports